import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const AmazonRedshiftWriterForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="amazonRedshiftWriterFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={form.formState.errors.name?.message}
      />
      <FormField
        controlId="amazonRedshiftWriterFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={form.formState.errors.type?.message}
      />
      <FormField
        controlId="amazonRedshiftWriterFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />

      <FormField
        controlId="amazonRedshiftWriterFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />

      <FormField
        controlId="amazonRedshiftWriterFormDatabaseName"
        label="databaseName"
        name="properties.databaseName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter database name"
        error={form.formState.errors.properties?.databaseName?.message}
      />

      <FormField
        controlId="amazonRedshiftWriterFormTableName"
        label="tableName"
        name="properties.tableName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter table name"
        required
        error={errors.properties?.tableName?.message}
      />

      <FormField
        controlId="amazonRedshiftWriterFormDriver"
        label="driver"
        name="properties.driver"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter driver"
        required
        error={errors.properties?.driver?.message}
      />

      <FormField
        controlId="amazonRedshiftWriterFormHost"
        label="host"
        name="properties.host"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter host"
        error={errors.properties?.host?.message}
      />

      <FormField
        controlId="amazonRedshiftWriterFormPort"
        label="port"
        name="properties.port"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter port"
        type="number"
        error={errors.properties?.port?.message}
      />

      <FormField
        controlId="amazonRedshiftWriterFormRootUrl"
        label="rootUrl"
        name="properties.rootUrl"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter root URL"
        error={errors?.properties?.rootUrl?.message}
      />
      <FormField
        controlId="amazonRedshiftWriterFormUsername"
        label="username"
        name="properties.username"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter username"
        error={errors?.properties?.username?.message}
      />
      <FormField
        controlId="amazonRedshiftWriterFormPassword"
        label="password"
        name="properties.password"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter password"
        error={errors?.properties?.password?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default AmazonRedshiftWriterForm;
